var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    fill: "#07F"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 7H16a8 8 0 00-8 8v32a8 8 0 008 8h32a8 8 0 008-8V15a8 8 0 00-8-8zm-5.677 35c-1.219-3.804-4.257-6.747-8.275-7.147V42h-.62C22.496 42 16.26 34.492 16 22h5.477c.18 9.169 4.217 13.053 7.415 13.854V22h5.157v7.908c3.158-.34 6.476-3.944 7.595-7.908h5.157c-.859 4.885-4.457 8.488-7.016 9.97C42.343 33.171 46.441 36.314 48 42h-5.677z"
  })));
}

export default SvgVk;